export const manifest = {
  screens: {
    scr_s706xq: { name: "Home", route: "/", position: {"x":160,"y":1820} },
    scr_wq2ql2: { name: "AI Booking", route: "/booking", position: {"x":1560,"y":1820} },
    scr_kofbkw: { name: "Supplier Results", route: "/results", position: {"x":2960,"y":1820} },
    scr_9oslm9: { name: "Payment", route: "/payment", position: {"x":5760,"y":1820} },
    scr_2hdr1q: { name: "Live Tracking", route: "/tracking", position: {"x":4360,"y":1820} },
    scr_wapatq: { name: "My Jobs", route: "/activity", position: {"x":160,"y":5780} },
    scr_roqbj7: { name: "Enterprise Dashboard", route: "/enterprise", position: {"x":160,"y":3800} },
    scr_6yirk7: { name: "Supplier Dashboard", route: "/supplier", position: {"x":1560,"y":3800} },
    scr_zrx1dk: { name: "Mobile App", route: "/mobile", position: {"x":0,"y":0}, isDefaultRow: true },
  },
  sections: {
    sec_vi9laj: { name: "Booking Journey", x: 0, y: 1600, width: 7120, height: 1180 },
    sec_4d2mii: { name: "Dashboards", x: 0, y: 3580, width: 2920, height: 1180 },
    sec_qoopsb: { name: "User Activity", x: 0, y: 5560, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "screen", id: "scr_zrx1dk" },
    { kind: "section", id: "sec_vi9laj", children: [
      { kind: "screen", id: "scr_s706xq" },
      { kind: "screen", id: "scr_wq2ql2" },
      { kind: "screen", id: "scr_kofbkw" },
      { kind: "screen", id: "scr_2hdr1q" },
      { kind: "screen", id: "scr_9oslm9" },
    ] },
    { kind: "section", id: "sec_4d2mii", children: [
      { kind: "screen", id: "scr_roqbj7" },
      { kind: "screen", id: "scr_6yirk7" },
    ] },
    { kind: "section", id: "sec_qoopsb", children: [
      { kind: "screen", id: "scr_wapatq" },
    ] },
  ],
}
